import { Component } from '@angular/core';
import { ApiService } from '../../services/Api.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../../public/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-jobs',
  standalone: false,
  templateUrl: './jobs.component.html'
})
export class JobsComponent {
  dataLoading = true;
  jobs: any = [];
  listData: any;
  search!: string;
  city_id: number[] = [];
  domain_id: number[] = [];

  pageTitle = 'Jobs';
  env = environment;

  pageIndx = 1;

  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    this.pageTitle = this.translate.instant('jobs.Jobs');
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['search']) {
        this.search = params['search'];
        this.pageTitle = this.search;
      }
      if (params['domain_id']) {
        this.domain_id = [params['domain_id']];
        if (params['domain_name']) {
          this.pageTitle = params['domain_name'];
        }
      }
      if (params['city_id']) {
        this.city_id = [params['city_id']];
        if (params['city_name']) {
          this.pageTitle = params['city_name'];
        }
      }
    })
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    let filter: any = { perPage: 8, page: this.pageIndx };
    if (this.search) {
      filter.search = this.search;
    }
    if (this.domain_id.length) {
      filter.domain_id = this.domain_id;
    }
    if (this.city_id) {
      filter.city_id = this.city_id;
    }
    this.apiService.getJobs(filter).subscribe((res: any) => {
      this.listData = res.data;
      this.jobs = this.jobs.concat(res.data.list);
      this.dataLoading = false;
    })
  }

  loadMore() {
    this.pageIndx += 1;
    this.getData();
  }

  showComp(job: any) {
    let html = `
          <div class='font-16 font-700 mb-4'>${job.job_title}</div>
          <div class='text-start'>`;
    job.competences.forEach((e: any) => {
      html += `
          <div class='mb-2'>
            <div class='badge badge-gray0${!e.selected ? ' opacity-50' : ''}'>${e.name}</div>
          </div>`;
    });
    html += '</div>'
    Swal.fire({
      // title: job.job_title,
      html,
      confirmButtonText: this.translate.instant('general.ok'),
    });
  }
}
